import { Immutable } from "immer";
import React from "react";

import styles from "./index.module.scss";

export const OrderConfirmationHeader = (
    props: Immutable<{ children: React.ReactNode }>,
): React.JSX.Element => {
    return (
        <div className={styles.orderConfirmationHeader}>{props.children}</div>
    );
};
